export default __webpack_public_path__ + "static/hq8-10ec4c229f1d519f4787b7baa7e4f4f5.jpg";